import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import SuccessModal from "../../SuccessModal";
import { canceledOrderB2B } from "../../../services/CancelOrder/canceledOrder";

export default function B2BOrderCancelModal({
  cancelOrderModal,
  setCancelOrderModal,
  sendDataToOrderInfoPage,
  storeId,
  storeCustomerId,
  bookingOrderId,
}) {
  const navigate = useNavigate();

  const [remarkValue, setRemarkValue] = useState("");
  const [remarkError, setRemarkError] = useState("");

  const handleConfirmCancelOrder = () => {
    if (remarkValue === "") {
      setRemarkError("Please enter a remark");
    } else {
      // Logic for creating a new pickup request
      const data = {
        remark: remarkValue,
      };
      canceledOrderB2B(storeCustomerId, storeId, bookingOrderId, data)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            if (Res) {
              const message = Res.message;
              const status = Res.status;
              if (status === true) {
                setModalVisible(true);
                setModalStatus("success");
                setModalText(message);
              } else {
                setModalVisible(true);
                setModalStatus("not Success");
                setModalText(message);
              }
              sendDataToOrderInfoPage({ dataRes: true });
              setRemarkValue("");
              setRemarkError("");
              setCancelOrderModal(false);
            }
          }
        })
        .catch((err) => {
          console.error("cancel Error:", err);
        });
    }
  };

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleModalClose = () => {
    setCancelOrderModal(false);
    setRemarkValue("");
    setRemarkError("");
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={cancelOrderModal}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!cancelOrderModal) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <i
                className="pi pi-cart-minus"
                style={{ fontSize: "50px", color: "#fff" }}
              ></i>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Confirm cancel challan
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div className="inline-flex flex-column gap-2 mx-4">
              <InputText
                value={remarkValue}
                onChange={(e) => setRemarkValue(e.target.value)}
                id="Remark"
                label="Remark"
                placeholder="Remark"
                className="w-full bg-white-alpha-20 border-round-lg px-3 text-md "
              ></InputText>
            </div>
            <div>
              <p className="text-xl font-normal mx-4" style={{ color: "red" }}>
                {remarkError}
              </p>
            </div>

            <Button
              onClick={handleConfirmCancelOrder}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                YES
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
}
